/* eslint-disable */
import {ScrollView, StyleSheet, Switch, Text, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTranslation} from 'react-i18next';
import OnboardingButton from '../../components/onboarding/OnboardingButton';
import StepHeader from '../../components/onboarding/StepHeader';
import SelectCard from '../../components/onboarding/SelectCard';
import {colors, radii, spacing, typography} from '../../config/theme';
import {formatSaving} from '../../config/onboardingData';
import AppIcon from '../../components/onboarding/AppIcon';
import {useOnboarding} from './OnboardingContext';

// Set to true to bring back the "Multiple vehicles?" option.
const SHOW_MULTIPLE_VEHICLES = false;

const FuelType = ({navigation}) => {
  const {t} = useTranslation();
  const {answers, update, config, currency, selectedFuel} = useOnboarding();
  const options = config.fuelType.options;

  return (
    <SafeAreaView style={styles.safe}>
      <StepHeader
        title={t('onboarding.vechileProfile', 'Vehcile Profile')}
        step={1}
        total={config.totalSteps}
        onBack={() => navigation.goBack()}
      />

      <ScrollView
        contentContainerStyle={styles.scroll}
        showsVerticalScrollIndicator={false}>
        <Text style={styles.title}>
          {t('onboarding.fuel.title', 'WHAT DOES YOUR CAR')}
          {'\n'}
          <Text style={styles.titleAccent}>
            {t('onboarding.fuel.titleAccent', 'DRINK?')}
          </Text>
        </Text>
        <Text style={styles.subtitle}>
          {t(
            'onboarding.fuel.subtitle',
            'Select fuel type for hyper-local price alerts and instant savings.',
          )}
        </Text>

        <View style={styles.grid}>
          {options.map(f => {
            const isSelected = selectedFuel.id === f.id;
            return (
              <SelectCard
                key={f.id}
                selected={isSelected}
                indicator="check"
                onPress={() => update({fuelType: f.id})}
                style={styles.tile}>
                <View style={[styles.iconWrap, isSelected && styles.iconWrapOn]}>
                  <AppIcon name={f.id} size={24} />
                </View>
                <View>
                  <Text style={styles.fuelName}>{f.label}</Text>
                  <Text style={styles.fuelSub}>{f.sublabel}</Text>
                </View>
                <View style={styles.gradePill}>
                  <Text style={styles.gradeText}>{f.chip}</Text>
                </View>
                <View style={styles.savePill}>
                  <Text style={styles.saveText}>
                    ↘ {t('onboarding.fuel.save', 'Save')} {formatSaving(f.saving, currency)}
                  </Text>
                </View>
              </SelectCard>
            );
          })}
        </View>

        {/* Multiple vehicles (hidden for now, see SHOW_MULTIPLE_VEHICLES) */}
        {SHOW_MULTIPLE_VEHICLES && (
          <View style={styles.multi}>
            <View style={styles.multiIcon}>
              <AppIcon name="car" size={22} />
            </View>
            <View style={styles.multiText}>
              <Text style={styles.multiTitle}>
                {t('onboarding.fuel.multiple', 'Multiple vehicles?')}
              </Text>
              <Text style={styles.multiSub}>
                {t('onboarding.fuel.multipleSub', 'Add extra cars & fuels later')}
              </Text>
            </View>
            <Switch
              value={answers.multipleVehicles}
              onValueChange={v => update({multipleVehicles: v})}
              trackColor={{false: colors.border, true: colors.secondary}}
              thumbColor={colors.surface}
            />
          </View>
        )}
      </ScrollView>

      <View style={styles.footer}>
        <OnboardingButton
          title={t('onboarding.next', 'NEXT STEP →')}
          onPress={() => navigation.navigate('RefuelFrequency')}
        />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safe: {flex: 1, backgroundColor: colors.background},
  scroll: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.lg,
    paddingBottom: spacing.lg,
    gap: spacing.md,
  },
  title: {...typography.displayMobile, color: colors.primary},
  titleAccent: {color: colors.secondary},
  subtitle: {...typography.bodyMd, color: colors.textMuted},

  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: spacing.md,
    marginTop: spacing.sm,
  },
  tile: {width: '48%', gap: spacing.sm},
  iconWrap: {
    width: 44,
    height: 44,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapOn: {backgroundColor: colors.mintSoft},
  icon: {fontSize: 20},
  fuelName: {...typography.headlineSm, color: colors.primary},
  fuelSub: {...typography.bodySm, color: colors.textMuted},
  gradePill: {
    alignSelf: 'flex-start',
    backgroundColor: colors.surfaceMuted,
    borderRadius: radii.pill,
    paddingHorizontal: spacing.sm,
    paddingVertical: 3,
  },
  gradeText: {...typography.labelSm, color: colors.textMuted},
  savePill: {
    alignSelf: 'flex-start',
    backgroundColor: colors.mintSoft,
    borderRadius: radii.pill,
    paddingHorizontal: spacing.sm,
    paddingVertical: 3,
  },
  saveText: {...typography.labelSm, color: colors.primary},

  multi: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    backgroundColor: colors.surfaceMuted,
    borderRadius: radii.card,
    padding: spacing.md + 4,
  },
  multiIcon: {
    width: 40,
    height: 40,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  multiText: {flex: 1},
  multiTitle: {...typography.labelLg, color: colors.primary},
  multiSub: {...typography.bodySm, color: colors.textMuted},

  footer: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.sm,
    paddingBottom: spacing.lg,
    backgroundColor: colors.background,
  },
});

export default FuelType;